// extracted by mini-css-extract-plugin
export default {"mobileHeaderBreakpoint":"639px"};